import { addDays, formatWeightChange, type LocalDate, type WeightUnit } from '@tahi/core';
import { copy } from './copy';

const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
const DAYS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

/** "Nov 3". */
export function shortDate(d: LocalDate): string {
  return `${MONTHS[Number(d.slice(5, 7)) - 1]} ${Number(d.slice(8, 10))}`;
}

/** "Today", "Yesterday", or "Mon, Nov 3". */
export function dayLabel(d: LocalDate, today: LocalDate): string {
  if (d === today) return copy.today;
  if (d === addDays(today, -1)) return 'Yesterday';
  const wd = new Date(`${d}T00:00:00Z`).getUTCDay();
  return `${DAYS[wd]}, ${shortDate(d)}`;
}

/** "−0.4 kg a week", or "Steady" when it rounds to zero. */
export function rateText(rateG: number | null, unit: WeightUnit): string {
  if (rateG === null) return copy.rateNotYet;
  const change = formatWeightChange(rateG, unit);
  return change.startsWith('0.0') ? copy.rateSteady : copy.ratePerWeek(change);
}
